export enum ENUM__sort_direction {
  A_TO_Z = 1,
  Z_TO_A = -1,
  NONE = 0,
}
